import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import * as getters from "./getters";
import { importModules } from "@/util";

const context = require.context("./modules", true, /\.js$/);

function setModuleDefaults(module) {
    // modules default to namespaced = true, but this can be overwritten.
    return Object.assign(
        {
            namespaced: true
        },
        module
    );
}

const modules = importModules(context, (key, item) => {
    // extract the module subdirectory name
    const name = key.replace(/^.*(\\|\/|:)|\..*$/g, "");
    return {
        [name]: setModuleDefaults(item.default)
    };
});

Vue.use(Vuex);

const debug = process.env.NODE_ENV === "development";

export default new Vuex.Store({
    actions,
    getters,
    modules,
    strict: debug
});
